// import { URLs } from '@common/api';
import { getData, URLs } from '@common/api';
import * as RichTextEditor from '@common/models/RichTextEditor';
import { call, ForkEffect, put, takeEvery } from 'redux-saga/effects';

import { fetchRichTextEditorFailure, fetchRichTextEditorRequest, fetchRichTextEditorSuccess } from './slice';

export function* fetchRichTextEditorSaga({ payload }: Record<string, string>): Generator<unknown> {
  try {
    const data = yield call(() => getData({ url: URLs.GET_RICH_TEXT_EDITOR.replace('{id}', payload) }));
    const result = RichTextEditor.processResponse(data.data);
    const { id } = data?.data;
    yield put(fetchRichTextEditorSuccess({ id: id, result }));
  } catch (e) {
    yield put(fetchRichTextEditorFailure('Request failed with hello heelloo: ' + e));
  }
}

export default function* richTextEditorSagas(): Generator<ForkEffect<never>, void, unknown> {
  yield takeEvery(fetchRichTextEditorRequest.type, fetchRichTextEditorSaga);
}
